import {combineReducers} from 'redux';
import LoginReducer from './LoginReducer';
import CountReducer from './CountReducer';



export default combineReducers({
    LoginReducer,CountReducer
})